function normalizeClipboardFile(file, index) {
  if (!file) return null;
  if (file.name && file.name.trim() !== '') return file;
  const type = file.type || 'application/octet-stream';
  let ext = 'bin';
  if (type === 'image/png') ext = 'png';
  else if (type === 'image/webp') ext = 'webp';
  else if (type === 'image/jpeg' || type === 'image/jpg') ext = 'jpg';
  else if (type === 'image/gif') ext = 'gif';
  else if (type.startsWith('image/')) ext = type.split('/')[1] || 'png';
  else if (type.startsWith('video/')) ext = type.split('/')[1] || 'mp4';
  return new File([file], `clipboard-${Date.now()}-${index}.${ext}`, { type });
}

export function extractFilesFromDataTransfer(dataTransfer) {
  if (!dataTransfer) return [];
  const fromFiles = dataTransfer.files ? Array.from(dataTransfer.files) : [];
  if (fromFiles.length) {
    return fromFiles.map((file, index) => normalizeClipboardFile(file, index)).filter(Boolean);
  }
  const fromItems = dataTransfer.items ? Array.from(dataTransfer.items) : [];
  const out = [];
  fromItems.forEach((item) => {
    if (item.kind !== 'file') return;
    const file = item.getAsFile();
    if (file) {
      const normalized = normalizeClipboardFile(file, out.length);
      if (normalized) out.push(normalized);
    }
  });
  return out;
}

function fileMatchesAcceptToken(file, token) {
  const trimmed = String(token || '').trim();
  if (!trimmed) return true;
  if (trimmed === '*/*') return true;
  const mime = (file.type || '').toLowerCase();
  const name = (file.name || '').toLowerCase();
  if (trimmed.endsWith('/*')) {
    const prefix = trimmed.slice(0, -1);
    return mime.startsWith(prefix);
  }
  if (trimmed.startsWith('.')) {
    return name.endsWith(trimmed.toLowerCase());
  }
  return mime === trimmed.toLowerCase();
}

export function filesMatchAccept(files, accept) {
  const list = Array.isArray(files) ? files : [];
  if (!list.length) return [];
  const acceptStr = String(accept || '').trim();
  if (!acceptStr || acceptStr === '*/*') return list;
  const tokens = acceptStr.split(',').map((t) => t.trim()).filter(Boolean);
  if (!tokens.length) return list;
  return list.filter((file) => tokens.some((token) => fileMatchesAcceptToken(file, token)));
}

export async function extractFilesFromClipboardApi() {
  if (!navigator.clipboard?.read) {
    return { files: [], unsupported: true };
  }
  try {
    const items = await navigator.clipboard.read();
    const out = [];
    for (const item of items) {
      const types = item.types || [];
      for (const type of types) {
        const blob = await item.getType(type);
        const ext = type.includes('/') ? type.split('/')[1] : 'bin';
        const file = new File([blob], `clipboard-${Date.now()}-${out.length}.${ext}`, { type });
        out.push(file);
      }
    }
    return { files: out, unsupported: false };
  } catch {
    return { files: [], unsupported: true };
  }
}
